export interface ModalAssets {
  bannerPath: string;
  buttonPath: string;
  storeLink: string;
}

// Base folder for modal images (under src/assets/img/download-modal)
export const DEFAULT_ASSETS_BASE = "assets/img/download-modal";

// Store links per language; replace with the real URLs for the app
export const STORE_LINKS: {
  [lang: string]: { ios: string; android: string };
} = {
  pt: {
    ios: "https://apps.apple.com/us/app/siila/id6760317086",
    android:
      "https://play.google.com/store/apps/details?id=com.siila.mobileapp&pcampaignid=web_share"
  },
  en: {
    ios: "https://apps.apple.com/us/app/siila/id6760317086",
    android:
      "https://play.google.com/store/apps/details?id=com.siila.mobileapp&pcampaignid=web_share"
  },
  es: {
    ios: "https://apps.apple.com/mx/app/siila/id6760317086",
    android:
      "https://play.google.com/store/apps/details?id=com.siila.mobileapp&pcampaignid=web_share"
  }
};
